export default "__VITE_ASSET__71fbfa01__"